import req from 'utils/request'
import qs from 'querystring'
import { IFilterParamsData } from 'store/interface'
import {
  ISchoolDetail,
  ISchoolIndicator,
  ISchoolOpenMajors,
  ISchoolGuideinfoList,
  ISchoolGuideinfoItem,
  ISchoolList,
  IMajorSearchParams,
  IMajorSearch,
  IMajorProbability,
  IHistoryScore,
  ISchoolLabels,
  ISchoolNameList
} from './interface'
import { RES_TYPES } from '../commonInterface'

// 院校列表
export const querySchoolList = (parmas: IFilterParamsData): RES_TYPES<ISchoolList> =>
  req.post('college/school/list', parmas)

// 院校信息概况
export const querySchoolDetail = (id: number, type: number = 1): RES_TYPES<ISchoolDetail> =>
  req.get(`college/school/introduction?schoolId=${id}&type=${type}`)

// 获取学校名字列表
export const querySchoolNameList = (id: number): RES_TYPES<ISchoolNameList> =>
  req.get(`college/search/enrollNameList?schoolId=${id}`)

// 院校指标
export const querySchoolIndicator = (id: number): RES_TYPES<ISchoolIndicator> =>
  req.get(`college/school/indicator?schoolId=${id}`)

// 开设专业
export const querySchoolOpenMajors = (id: number): RES_TYPES<ISchoolOpenMajors> =>
  req.get(`college/school/openMajors?schoolId=${id}`)

// 招生简章列表
export const querySchoolGuideinfoList = (params): RES_TYPES<ISchoolGuideinfoList> =>
  req.get(`college/schoolguideinfo/list?${qs.stringify(params)}`)

// 招生简章明细
export const querySchoolGuideinfoDetail = (
  id: number,
  schoolId: number
): RES_TYPES<ISchoolGuideinfoItem> =>
  req.get(`college/schoolguideinfo/detail?guideId=${id}&schoolId=${schoolId}`)

// 专业录取数据和招生计划
export const queryMajorSearch = (params: IMajorSearchParams): RES_TYPES<IMajorSearch> =>
  req.post('college/search/majorSearch', params)

// 录取概率
export const queryMajorProbability = (name: string, id: number): RES_TYPES<IMajorProbability> =>
  req.get(`college/major/probability?enrollName=${name}&schoolId=${id}`)

// 历年分数
export const queryHistoryScore = (name: string, id: number): RES_TYPES<IHistoryScore> =>
  req.get(`college/search/historyScore?enrollName=${encodeURIComponent(name)}&schoolId=${id}`)

/**
 * 获取筛选条件列表
 * https://yapi.inner.youdao.com/project/146/interface/api/96392
 */
export const getSchoolLabels = (type: 1 | 2): RES_TYPES<ISchoolLabels[]> =>
  req.get(`college/config/schoolLabels?type=${type}`)
